import React from 'react'

class FilterComponent extends React.Component {
  render () {
    return (
      <div
        style={{
          height: '100%',
          width: '100%'
        }}
      >
        FilterComponent
      </div>
    )
  }
}

export default FilterComponent
